import { render, staticRenderFns } from "./DateMixin.js.vue?vue&type=template&id=be45c45a&"
import script from "./DateMixin.js.vue?vue&type=script&lang=js&"
export * from "./DateMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports